import React, { useState } from 'react';
import PreserveFormatting from 'components/shared/PreserveFormatting/index';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';

export const eventLengthCheck = eventDescriptionLength => {
  const show = eventDescriptionLength > 300;
  return show;
};

export const ShowMore = ({ children }) => {
  const text = children;
  const [isShowMore, setIsShowMore] = useState(true);
  const toggleShowMore = () => {
    setIsShowMore(!isShowMore);
  };
  return (
    <p className="text">
      <PreserveFormatting>
        {isShowMore ? `${text.slice(0, 300)}... ` : text}
      </PreserveFormatting>
      <button
        className="u-resetBtn"
        type="button"
        onClick={e => {
          e.preventDefault();
          toggleShowMore();
        }}
      >
        <Text
          className="mt-16 h-td-u u-inline"
          variant={TEXT_VARIANTS.BODY_LINK}
        >
          {isShowMore ? t('common.show_more') : t('common.show_less')}
        </Text>
      </button>
    </p>
  );
};

export const isEventAtCapacity = (sessions, isSeries) => {
  if (isSeries) {
    return sessions?.some(session => {
      const maxAttendees = session.maxAttendees || session.max_attendees;
      const totalRegistered =
        session.totalRegistered || session.total_registered;
      return maxAttendees && totalRegistered >= maxAttendees;
    });
  }
  return sessions?.every(session => {
    const maxAttendees = session.maxAttendees || session.max_attendees;
    const totalRegistered = session.totalRegistered || session.total_registered;
    return maxAttendees && totalRegistered >= maxAttendees;
  });
};

export const getSeriesRegistrationCap = sessions => {
  const sessionsWithMaxAttendees = sessions?.filter(
    session => session.maxAttendees || session.max_attendees,
  );
  if (sessionsWithMaxAttendees.length) {
    const initialValue =
      sessionsWithMaxAttendees[0].maxAttendees ||
      sessionsWithMaxAttendees[0].max_attendees;
    const lowestRegistrationCap = sessionsWithMaxAttendees.reduce(
      (prev, curr) => {
        const currMaxAttendees = curr.maxAttendees || curr.max_attendees;
        return prev < currMaxAttendees ? prev : currMaxAttendees;
      },
      initialValue,
    );
    return lowestRegistrationCap;
  }
  return null;
};

export const getRsvpSingleRegistrationCap = sessions => {
  const sessionsWithMaxAttendees = sessions?.filter(
    session => session.maxAttendees || session.max_attendees,
  );
  if (sessionsWithMaxAttendees.length) {
    const initialValue =
      sessionsWithMaxAttendees[0].maxAttendees ||
      sessionsWithMaxAttendees[0].max_attendees;
    return sessions?.reduce((prev, curr) => {
      const currMaxAttendees = curr.maxAttendees || curr.max_attendees;
      return prev === currMaxAttendees
        ? prev
        : t(
            'in_person_training.event_overview.registration_cap.varies_by_session',
          );
    }, initialValue);
  }
  return null;
};

export const getSeriesTotalRegistered = sessions => {
  const sessionsWithTotalRegistered = sessions?.filter(
    session => session.totalRegistered || session.total_registered,
  );
  if (sessionsWithTotalRegistered.length) {
    const initialValue =
      sessionsWithTotalRegistered[0].totalRegistered ||
      sessionsWithTotalRegistered[0].total_registered;
    return sessions?.reduce((prev, curr) => {
      const currTotalRegistered = curr.totalRegistered || curr.total_registered;
      return prev > currTotalRegistered ? prev : currTotalRegistered;
    }, initialValue);
  }
  return null;
};
